var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "status-tracker-wrapper" }, [
    _c("div", { staticClass: "status-titles" }, [
      _c("div", { staticStyle: { "flex-grow": "0.2" } }, [_vm._v("Sent")]),
      _vm._v(" "),
      _c("div", [_vm._v("Processing")]),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "danger-text": _vm.status === "Completed (No Records Found)"
          }
        },
        [_vm._v("Completed")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "status-tracker" }, [
      _c("div", {
        staticClass: "status-circle-outline",
        class: { "status-circle-filled": _vm.status === "Sent" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "status-line" }),
      _vm._v(" "),
      _c("div", {
        staticClass: "status-circle-outline",
        class: { "status-circle-filled": _vm.status === "Processing" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "status-line" }),
      _vm._v(" "),
      _c("div", {
        staticClass: "status-circle-outline",
        class: { "status-circle-filled": _vm.status === "Completed" }
      })
    ]),
    _vm._v(" "),
    _vm.status === "Completed (No Records Found)"
      ? _c(
          "div",
          { staticClass: "no-results" },
          [
            _c(
              "v-icon",
              { staticStyle: { color: "#ff0000", "margin-right": "5px" } },
              [_vm._v("mdi-alert-circle-outline")]
            ),
            _vm._v("\n    No Records Found\n  ")
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }